import React from 'react';
import T from 'prop-types';
import { Button } from '@acast/decibel';
import { UploadLightGlyph } from '@acast/decibel-glyphs';

const AudioFileUpload = ({ onUpload }) => {
  const uploadInput = React.createRef();

  const handleClick = () => uploadInput.current.click();

  return (
    <div className="editor-controls__item-container">
      <input
        type="file"
        accept="audio/mp3, audio/mpeg"
        id="editor-audio-file-input"
        onChange={onUpload}
        ref={uploadInput}
        hidden
        data-test-id="AudioFileUpload__input"
      />
      <Button
        size="small"
        variant="secondary"
        glyph={UploadLightGlyph}
        onClick={handleClick}
        data-test-id="AudioFileUpload__button"
      >
        Replace File
      </Button>
    </div>
  );
};

AudioFileUpload.propTypes = {
  onUpload: T.func.isRequired,
};

export default AudioFileUpload;
